export interface TelemetryIndex {
  byDistance: Map<number, number>
  byTime: Map<number, number>
  byTimestamp: Map<number, number>
}

export interface IndexCreationOptions {
  distanceResolutionMeters?: number
  timeResolutionMs?: number
}

const DEFAULT_OPTIONS: Required<IndexCreationOptions> = {
  distanceResolutionMeters: 5,
  timeResolutionMs: 100,
}

export function createTelemetryIndex<
  T extends { distanceMeters: number; elapsedMs: number; timestamp: Date },
>(points: T[], options: IndexCreationOptions = {}): TelemetryIndex {
  const opts = { ...DEFAULT_OPTIONS, ...options }

  const byDistance = new Map<number, number>()
  const byTime = new Map<number, number>()
  const byTimestamp = new Map<number, number>()

  points.forEach((point, index) => {
    const roundedDistance =
      Math.round(point.distanceMeters / opts.distanceResolutionMeters) *
      opts.distanceResolutionMeters

    const roundedTime =
      Math.round(point.elapsedMs / opts.timeResolutionMs) *
      opts.timeResolutionMs

    const roundedTimestamp = Math.round(point.timestamp.getTime() / 1000) * 1000

    if (!byDistance.has(roundedDistance)) {
      byDistance.set(roundedDistance, index)
    }
    if (!byTime.has(roundedTime)) {
      byTime.set(roundedTime, index)
    }
    if (!byTimestamp.has(roundedTimestamp)) {
      byTimestamp.set(roundedTimestamp, index)
    }
  })

  return { byDistance, byTime, byTimestamp }
}
